<template>
    <v-row justify="center">
        <v-dialog v-model="visible" max-width="60%">
            <v-card>
                <v-card-title>
                    <span class="headline primary--text">Upload response Excel file from offer</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <label>
                            Select offer response file.
                            <input type="file" id="fileUploadInput" v-on:change="selectFile()" />
                        </label>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                    <v-btn color="primary" @click="onSingleFileUpload()">
                        Upload excel file.
                    </v-btn>
                    <br />
                    <v-container fill-height>
                        <v-layout align-center justify-center>
                            <div v-if="showParseResult" id="hide">
                                <b>Items that failed to automaticly import. </b> <br />
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="user in parseResult" :key="user.Name">
                                            <td>{{user.Name}}</td>
                                            <td>{{user.Status}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-layout>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        name: "offeruploadexcel",
        props: {
            visible: Boolean,
        },
        data: function () {
            return {                
                offerId: null,
                file: undefined,
                parseResult: undefined,
                showParseResult: undefined,
            };
        },
        methods: {
            Show: function (id) {
                this.offerId = id;
                this.visible = true;
                this.showParseResult = false;
                this.parseResult = [];

                var input = document.getElementById("fileUploadInput");
                if (input) {
                    input.value = "";
                }
            },
            onModalShown: function () {
                
            },
            onModalClose: function () {
                this.$emit("closeModal");
            },
            selectFile() {
                this.selectedFiles = event.target.files;
            },
            setParseResult: function (data) {
                this.parseResult = data;
                this.showParseResult = true;
            },
            onSingleFileUpload: function () {
                var formData = new FormData();
                for (var i = 0; i < this.selectedFiles.length; i++) {
                    let file = this.selectedFiles[i];
                    formData.append('files[' + i + ']', file);
                }

                this.showParseResult = false;
                var url = `${process.env.VUE_APP_API_URL}/ProjectsApi/UploadOfferExcel?offerId=${this.offerId}`;
                axios.post(url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                })
                    .then(response => (this.setParseResult(response.data) ))
                    .catch(function (error) {
                        if (process.env.VUE_APP_ENVIRONMENT == "local" || process.env.VUE_APP_ENVIRONMENT == "dev") {
                            alert("Error uploading document" + error);
                        } else {
                            console.log("Error uploading document" + error);
                        }
                    });


            }
        },
        computed: {
            uploadExceLVisible() {
                if (visible)
                    return true;

                return false;
            },
        },
    };
</script>



<style scoped>
    .weather-data {
        display: flex;
        align-items: center;
        margin-top: 20px;
        margin-left: 20px;
        border-bottom: 2px solid #ccc;
        padding: 20px;
    }

    .weather-icon {
        flex-grow: 1;
    }

    .weather-stats {
        flex-grow: 8;
        text-align: left;
        padding-left: 20px;
    }

        .weather-stats .location {
            font-size: 30px;
        }

    .weather-temp {
        flex-grow: 1;
        font-size: 35px;
    }

    img {
        width: 70px;
    }

    button {
        padding: 10px;
        background-color: #1aa832;
        color: white;
        border: 1px solid #ccc;
    }
</style>